module.exports = __webpack_public_path__ + "static/media/tejas.15e140c5.png";